import { CfCard9Props } from "./schema";
import Card9, { Card9Props } from "..";
import React from "react";

export const convertCfCard9Props = ({ logo, label, promo }: CfCard9Props) => {
  const props: Card9Props = {
    label,
    imageSrc: logo.file.url,
    isPromo: promo,
  };
  return props;
};

const CfServicePreviewCard = (props: CfCard9Props) => {
  return <Card9 {...convertCfCard9Props(props)} />;
};

export default CfServicePreviewCard;
